export const MembershipColorSchemes = {
  white: {
    bg: 'bg-white',
    text: 'text-evergreen-900',
    textMuted: 'text-evergreen-900/80',
    divider: 'bg-evergreen-900/30',
    icon: 'text-evergreen-500',
    buttonColor: 'default',
  },
  'evergreen-1': {
    bg: 'bg-evergreen-100',
    text: 'text-evergreen-700',
    textMuted: 'text-evergreen-700/80',
    divider: 'bg-evergreen-700/30',
    icon: 'text-evergreen-600',
    buttonColor: 'default',
  },
  'evergreen-2': {
    bg: 'bg-evergreen-400',
    text: 'text-primary-foreground',
    textMuted: 'text-primary-foreground/70',
    divider: 'bg-primary-foreground/30',
    icon: 'text-primary-foreground',
    buttonColor: 'inverse',
  },
  'evergreen-3': {
    bg: 'bg-evergreen-600',
    text: 'text-primary-foreground',
    textMuted: 'text-primary-foreground/80',
    divider: 'bg-primary-foreground/30',
    icon: 'text-primary-foreground',
    buttonColor: 'inverse',
  },
  'evergreen-4': {
    bg: 'bg-evergreen-800',
    text: 'text-primary-foreground',
    textMuted: 'text-primary-foreground/80',
    divider: 'bg-primary-foreground/30',
    icon: 'text-tuscany-300',
    buttonColor: 'inverse',
  },
  'tuscany-1': {
    bg: 'bg-tuscany-100',
    text: 'text-tuscany-900',
    textMuted: 'text-tuscany-900/80',
    divider: 'bg-tuscany-900/60',
    icon: 'text-tuscany-900',
    buttonColor: 'default',
  },
  'tuscany-2': {
    bg: 'bg-tuscany-600',
    text: 'text-primary-foreground',
    textMuted: 'text-primary-foreground/80',
    divider: 'bg-primary-foreground/30',
    icon: 'text-primary-foreground',
    buttonColor: 'inverse',
  },
  'tuscany-3': {
    bg: 'bg-tuscany-300',
    text: 'text-tuscany-900',
    textMuted: 'text-tuscany-900/80',
    divider: 'bg-tuscany-900/30',
    icon: 'text-tuscany-900',
    buttonColor: 'inverse',
  },
  'tuscany-4': {
    bg: 'bg-tuscany-800',
    text: 'text-primary-foreground',
    textMuted: 'text-primary-foreground/80',
    divider: 'bg-primary-foreground/30',
    icon: 'text-primary-foreground',
    buttonColor: 'inverse',
  },
}

export type MembershipColorSchemeKey = keyof typeof MembershipColorSchemes
export type MembershipColorScheme = (typeof MembershipColorSchemes)[MembershipColorSchemeKey]
